import React, { useState } from 'react'
import { Label, Icon, Input } from 'semantic-ui-react';
import PropTypes from 'prop-types'
import { parseEmailList } from '../utils/classLeaderEmails';

export const EmailTagInput = ({
    emails = [],
    onChange,
    onInvalid,
    placeholder = 'Enter emails'
}) => {
    const [inputValue, setInputValue] = useState('');

    const commitText = (text) => {
        const trimmed = String(text || '').trim();
        if (trimmed === '') {
            return;
        }

        const { emails: parsed, invalid } = parseEmailList(trimmed);

        const existingLowercase = {};
        (emails || []).forEach((email) => {
            existingLowercase[String(email).toLowerCase()] = true;
        });

        const newEmails = parsed.filter((email) => !existingLowercase[email.toLowerCase()]);

        if (newEmails.length > 0) {
            onChange([...emails, ...newEmails]);
        }

        if (invalid.length > 0 && onInvalid) {
            onInvalid(invalid);
        }
    };

    const handleKeyDown = (event) => {
        if (event.key === 'Enter' || event.key === ',' || event.key === ';') {
            event.preventDefault();
            commitText(inputValue);
            setInputValue('');
        } else if (event.key === 'Tab') {
            commitText(inputValue);
            setInputValue('');
        }
    };

    const handlePaste = (event) => {
        const clipboardData = event.clipboardData;
        if (!clipboardData) {
            return;
        }
        const pastedText = clipboardData.getData('text');
        if (pastedText) {
            event.preventDefault();
            commitText(pastedText);
            setInputValue('');
        }
    };

    const handleBlur = () => {
        commitText(inputValue);
        setInputValue('');
    };

    const handleChange = (event) => {
        setInputValue(event.target.value);
    };

    const removeEmail = (emailToRemove) => {
        onChange(emails.filter((email) => email !== emailToRemove));
    };

    return (
        <div>
            {(emails || []).map((email) => (
                <Label key={email} style={{ margin: '2px' }}>
                    {email}
                    <Icon
                        name='delete'
                        data-testid={`remove-${email}`}
                        onClick={() => removeEmail(email)}
                    />
                </Label>
            ))}
            <Input
                placeholder={placeholder}
                value={inputValue}
                onChange={handleChange}
                onKeyDown={handleKeyDown}
                onPaste={handlePaste}
                onBlur={handleBlur}
            />
        </div>
    );
};

EmailTagInput.propTypes = {
    emails: PropTypes.arrayOf(PropTypes.string),
    onChange: PropTypes.func.isRequired,
    onInvalid: PropTypes.func,
    placeholder: PropTypes.string
};

EmailTagInput.defaultProps = {
    emails: [],
    placeholder: 'Enter emails'
};
